module.exports = __webpack_public_path__ + "d17b74558992d55a3d190ffed1ea1fbd.pdf";